<template>
  <div id="app">
    <ParticleCanvas />
    <div class="app-content">
      <router-view />
    </div>
  </div>
</template>

<script>
import ParticleCanvas from './components/ParticleCanvas.vue'
export default {
  name: 'App',
  components: { ParticleCanvas },
}
</script>

<style>
html, body, #app { height: 100%; margin: 0; }
body { background: #FFFFFF; }
#app { position: relative; }
.app-content { position: relative; z-index: 1; }
</style>
